import { Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

import carPlaceholder from '../../../../assets/img/car_placeholder.jpg';


export const HeaderForm = ({ useFetchInit }) => {

  const {
    globalStates,
    Actions, 
    Forms
  } = useFetchInit

  const {handleNextImage, handlePreviousImage} = Actions 
  const {FormVehicle:{formState}} = Forms

  const {imagesCurrentIndex} = globalStates


  const images = formState.images

  const currentImage =
  images && images.length > 0
    ? images[imagesCurrentIndex]?.document_path
    : carPlaceholder;

  const {showSection} = globalStates
  return (
    <Grid
      container
      spacing={2}
      style={{ marginTop: '1rem' }}
      alignItems="center"
      justifyContent="center"
    >
    <Grid item xs={12} sm={8} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <img
        src={currentImage}
        alt="Vehicle"
        style={{
          width: '60vw',
          height: '50vh',
          objectFit: 'contain',
          borderRadius: '8px',
          maxWidth: '100%', 
          maxHeight: '100%',
        }}
      />
    </Grid>
    <Grid item xs={12} sm={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2}}>
      <div 
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',                  
          maxWidth: '26rem',              
        }}
      >
        <Button
            startIcon={<ArrowLeftCircle size={40}/>}
            variant="contained"
            type="button"
            className='btn-round'
            color='inherit'
            sx={{ height: '5rem', width: '13rem'}}
            onClick={handlePreviousImage}
        ></Button>

        <Button
            startIcon={<ArrowRightCircle size={40}/>}
            variant="contained"
            type="button"
            className='btn-round'
            color='inherit'
            sx={{height: '5rem', width: '13rem'}}
            onClick={handleNextImage}
        ></Button>
      </div>
      {(showSection!=='IMAGES') && (
        <Typography 
          variant="h4" 
          sx={{ textAlign: 'center', mt: 2 }} 
        >
          {(formState.idvehicle>0) ?("Costo Total: Q." + formState.costo_total) : ''}
        </Typography>
      )}

    </Grid>
  </Grid>
  )
}
